/*
Version 0.110

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	08-03-2019
	- [CHANGE] Added variable check to set height and with when not given in on windowResize();
	11-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_window = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	// none
	
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
		/**
		Window: resize
		**/
		this.windowResize = function(scrolled,h,w) {
			
			/*
			Set: Variables
			*/
			if(typeof h === 'undefined') {
				h = $(window).height();
			}
			if(typeof w === 'undefined') {
				w = $(window).width();
			}
			
			document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');

			/*
			Change window settings width
			Change window settings width
			Change window settings width
			Change window settings width
			*/
			// if(isFirstLoad == 0) {
		
			// Resize on view
			if(
				w < 1200 
			) {

				if(isKRPanoLoaded == 1) {

					//krpano.call('set("view.fov",70)');

				}

			}
			
		};
		
		/**
		Window: scroll
		**/
		this.windowScroll = function(scrolled,h,w) {
	
		};
		
		
		/**
		Window: orientation
		**/
		this.windowOrientationChange = function() {

			/*
			Trigger: toggleInfo
			*/
			//specific_360.toggleInfo(0);
			
		};
		
}).apply(specific_interactions_window); 